import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export function useQueryParams(initialQueryParams = {}) {
  const [searchParams, setSearchParams] = useSearchParams(initialQueryParams);

  const queryParams = useMemo(
    () => Object.fromEntries([...searchParams]),
    [searchParams]
  );

  const setQueryParams = useCallback(
    (value, navigateOptions = {}) => {
      if (typeof value === "function") {
        const newSearchParams = value(Object.fromEntries([...searchParams]));

        return setSearchParams(newSearchParams, navigateOptions);
      }

      setSearchParams(value, navigateOptions);
    },
    [searchParams, setSearchParams]
  );

  return {
    queryParams,
    setQueryParams,
  };
}
